import { AssetAlignmentType } from './AssetAlignment';

// TODO: It will be better to use block data level for the alignment configuration instead of block type level
export enum TextHorizontalAlignmentType {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  JUSTIFY = 'justify',
  UNORDERED_LIST = 'unordered-list-item',
}

// TODO: [#defaultStyles] we need to move all default styles to 1 place
export const DefaultTextAlignment = TextHorizontalAlignmentType.LEFT;

export const TextAlignmentMap: PartialRecord<TextHorizontalAlignmentType, AssetAlignmentType> = {
  [TextHorizontalAlignmentType.LEFT]: AssetAlignmentType.LEFT,
  [TextHorizontalAlignmentType.CENTER]: AssetAlignmentType.HORIZONTAL_CENTER,
  [TextHorizontalAlignmentType.RIGHT]: AssetAlignmentType.RIGHT,
};
